var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgQuestionMark = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 14.25C10.9518 14.25 13.75 11.4518 13.75 8C13.75 4.54822 10.9518 1.75 7.5 1.75C4.04822 1.75 1.25 4.54822 1.25 8C1.25 11.4518 4.04822 14.25 7.5 14.25Z",
    fill: "#8E93A0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.68127 6.125C5.82821 5.7073 6.11824 5.35507 6.5 5.13071C6.88175 4.90635 7.33058 4.82434 7.76701 4.8992C8.20343 4.97406 8.59928 5.20096 8.88445 5.53971C9.16961 5.87846 9.32568 6.30721 9.32502 6.75C9.32502 8 7.45002 8.625 7.45002 8.625",
    stroke: "#F6F8F9",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 11.125H7.50542",
    stroke: "#F6F8F9",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgQuestionMark, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/question-mark.230e756f.svg";
export { ForwardRef as ReactComponent };